import React from 'react'

import { ChevronRight } from '~/icons/ChevronRight'

const SliderNav = ({
  prevSlide,
  nextSlide,
  canNextSlide,
  canPrevSlide,
  iconColor,
}) => {
  return (
    <div className="slider-nav">
      <button
        className={`${!canPrevSlide ? 'is-disabled' : ''} slider-nav__prev`}
        onClick={prevSlide}
      >
        <span className="sr-only">Previous</span>
        <ChevronRight className={`icon-${iconColor}`} />
      </button>
      <button
        className={`${!canNextSlide ? 'is-disabled' : ''} slider-nav__next`}
        onClick={nextSlide}
      >
        <span className="sr-only">Next</span>
        <ChevronRight className={`icon-${iconColor}`} />
      </button>
    </div>
  )
}

export default SliderNav
